import { eventApi } from "shared/api/eventApi";

export const eventRegisterRequest = (payload) => {
  return eventApi.eventRegister(payload);
};
